import { SvgIcon } from "@mui/material";
import { CSSProperties } from "react";

const UpDownChevronIcon = ({
  scale,
  rotate,
  color,
  style,
}: {
  scale?: number;
  rotate?: number;
  color?: string;
  style?: CSSProperties;
}) => {
  let c = "#95A3B5";
  if (color) c = color;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `scale(${scale || 1})`, rotate: `${rotate || 0}deg`, ...style }}
    >
      <path
        d="M9.99338 15.8319C9.85455 15.8322 9.72 15.7838 9.6131 15.6951L6.04791 12.7204C5.92656 12.6194 5.85025 12.4743 5.83577 12.317C5.82128 12.1597 5.8698 12.0031 5.97066 11.8816C6.07152 11.7601 6.21645 11.6837 6.37357 11.6692C6.53069 11.6547 6.68714 11.7033 6.80848 11.8042L9.99338 14.4695L13.1783 11.8994C13.2391 11.85 13.309 11.8131 13.3841 11.7908C13.4591 11.7686 13.5379 11.7614 13.6157 11.7697C13.6936 11.778 13.769 11.8016 13.8377 11.8392C13.9065 11.8767 13.9671 11.9275 14.0161 11.9887C14.0705 12.0498 14.1117 12.1216 14.1372 12.1995C14.1626 12.2773 14.1717 12.3596 14.1639 12.4411C14.1561 12.5227 14.1315 12.6017 14.0918 12.6733C14.052 12.7449 13.998 12.8076 13.9329 12.8573L10.3677 15.7308C10.2578 15.8054 10.1259 15.8411 9.99338 15.8319Z"
        fill={c}
      />
      <path
        d="M10.0066 4.16808C10.1455 4.16781 10.28 4.21623 10.3869 4.30492L13.9521 7.27957C14.0734 7.38055 14.1497 7.52566 14.1642 7.68298C14.1787 7.84029 14.1302 7.99693 14.0293 8.11842C13.9285 8.23992 13.7835 8.31632 13.6264 8.33083C13.4693 8.34533 13.3129 8.29675 13.1915 8.19576L10.0066 5.53048L6.82171 8.10058C6.76093 8.14999 6.691 8.1869 6.61593 8.20917C6.54086 8.23144 6.46213 8.23863 6.38428 8.23034C6.30642 8.22205 6.23097 8.19843 6.16226 8.16085C6.09354 8.12326 6.03293 8.07245 5.9839 8.01134C5.92948 7.95016 5.88827 7.8784 5.86284 7.80054C5.83741 7.72268 5.82832 7.6404 5.83613 7.55886C5.84394 7.47731 5.86848 7.39826 5.90822 7.32666C5.94796 7.25506 6.00205 7.19244 6.06708 7.14274L9.63227 4.26922C9.74225 4.19455 9.87405 4.15894 10.0066 4.16808Z"
        fill={c}
      />
    </svg>
  );
};

export default UpDownChevronIcon;
